import InputTotals from "./InputTotals";
import InputCostAllocation from "./InvoiceCostAllocation";
// src/components/intrare/Form.jsx
import React, {
  useMemo,
  useEffect,
  useState,
  useCallback,
  useRef,
} from "react";
import {
  Modal,
  Form,
  Row,
  Col,
  Table,
  Button,
  InputGroup,
  Alert,
} from "react-bootstrap";
import DatePicker from "react-datepicker";
import { format, parseISO, isValid as isValidDate } from "date-fns";
import { formatDateISO, parseNumber } from "./formatters";
import { authFetch } from "../utils/authFetch";
import api from "../../axiosConfig";
import { AsyncPaginate } from "react-select-async-paginate";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Badge } from "react-bootstrap";
import { toast } from "react-toastify";
import ClientPickerModal from "../pickers/ClientPickerModal";
import TipFacturaIntrarePickerModal from "../pickers/TipFacturaIntrarePickerModal";
import AvizePickerModal from "./AvizePickerModal";
import StornoPickerModal from "./StornoPickerModal";
import PartPickerModal from "../pickers/PartPickerModal";
import CostCentePickerModal from "../pickers/TipFacturaPickerModal";
import AccountPickerModal from "../pickers/AccountPickerModal";
import VatPickerModal from "../pickers/VatPickerModal";
import { components } from "react-select";
import { changeIntrareDocument, intrareClassificationLabel } from "../utils/documentClassification";
export const emptyIntrare = () => ({
  tip_document: "Factura",
  doc_no: "",
  doc_date: new Date().toISOString().slice(0, 10) + "T00:00:00",
  contact_id: 0,
  tip_factura: 1,
  tip_factura_label: "Normală",
  observatii: "",
  comanda_client: "",
  proiect_client: "",
  bxfinal_bool: false,
  linii: [],
});
const emptyLine = () => ({
  uid: makeUid(),

  stock_total: 0,
  loadingAvail: false,

  alloc: [], // [{bxstocin_id, qty}]
  stock_err: "",

  id: null,
  bxgestiune_id: null,
  bxpart_id: null,
  descriere: "",
  qty: 0,
  price: 0,
  vat_rate: 0,
  cont_venit_id: null,
  cont_tva_id: null,
  cont_client_id: null,
  bxpart_label: "",
});
const makeUid = () => {
  if (typeof crypto !== "undefined" && crypto.randomUUID)
    return crypto.randomUUID();
  return `uid_${Date.now()}_${Math.random().toString(16).slice(2)}`;
};
const toYMD = (d) => (d && isValidDate(d) ? format(d, "yyyy-MM-dd") : "");
const fromISOToDate = (iso) => {
  try {
    return iso ? parseISO(iso) : null;
  } catch {
    return null;
  }
};
const debugging = localStorage.getItem("firma_debugging") === "1";
console.log("debugging", debugging);
const ymdToISODateTime = (ymd, hh = "00", mm = "00") =>
  ymd ? `${ymd}T${hh}:${mm}:00` : "";

// cat aducem per pagina in selectorul de contacte
const LIMIT = 20;
const PART_LIMIT = 20;

export function useEmptyIntrare() {
  return useMemo(
    () => ({
      tip_document: "Factura",
        bxfinal_bool: 0,
      tip_factura: 1,
      tip_factura_label: "Normală",
      contact_id: 0,
      contract_id: null,
      bxdoc_date: formatDateISO(new Date()),
      bxinput_date: formatDateISO(new Date()),
      bxdoc_no: "",
      bxvaluta_id: 1,
      bxvaluta_curs: "1.0000",
      bxcurs_invoice: null,
      bxgvalue: "0.00",
      bxsettled_value: "0.00",
      bxdatascadenta: formatDateISO(
        new Date(Date.now() + 30 * 24 * 60 * 60 * 1000),
      ),
      bxstorno_id: null,
      bxsold: "0.00",
      bxsoldint: 1,
      taxa_inversa: null,
      bxcomunitar: null,
      e_tva_inc: 0,
      bxseria: "",
      bxdescr: "",
      tip_394: 0,
      e_simplificata: 0,
      valuta_lei: 0,
      bxcont_id: 1,
      linii: [
        {
          bxcomanda_id: null,
          bxpart_id: 0,
          bxgestiune_id: 0,
          bxum_id: 1,
          bxcantitate: 1,
          bxvprice: 0,
          bxvamount: 0,
          bxvatv_amount: 0,
          bxtotalv_amount: 0,
          bxvat_id: 1,
          centrucost_id: null,
          bxid3: null,
          bxdescr: "",
          bxtvataxare: null,
          bxcust_id: null,
          pretvanzare: null,
          pradaos: null,
          e_pret_catalog: null,
          nr_lot: "",
          data_expirare: formatDateISO(
            new Date(Date.now() + 365 * 24 * 60 * 60 * 1000),
          ),
          observatii: "",
          taxa_verde: null,
          bxcont_id: 1,
        },
      ],
    }),
    [],
  );
}

export default function IntrareForm({
  value: propsValue,
  onChange,
  onSubmit,
  locked,
  initial,
  submitting,
  fixedDocumentType = null,
  allocationRef,
}) {
  const uniq = useMemo(() => Math.random().toString(36).slice(2, 11), []);
  // const [value, onChange?.] = useState(propsValue ?? {});

  // useEffect(() => {
  //   onChange?.(propsValue ?? {});
  // }, [propsValue]);

  // const setField = (name, val) => {
  //   onChange?.((prev) => {
  //     const next = { ...prev, [name]: val };
  //     onChange?.(next);
  //     return next;
  //   });
  // };

  const value = propsValue ?? {};

  const setField = (name, val) => {
    onChange?.({ ...value, [name]: val });
  };

  const [selectedContact, setSelectedContact] = useState(null);
  const [tipFacturaOptions, setTipFacturaOptions] = useState([]);
  const [selectedPartByIndex, setSelectedPartByIndex] = useState({});
  const partCache = useRef(new Map()); // id -> { id, cod, denumire, um_id, ... }
  const [showVatModal, setShowVatModal] = useState(false);
  const [isPlatitorTva, setIsPlatitorTva] = useState(true);
  const [distribuirePeCentre, setDistribuirePeCentre] = useState(false);
  const [vatPicker, setVatPicker] = useState({ show: false, row: null });
  const openVatPicker = (row_uid) => {
    setVatPicker({ show: true, row: row_uid });
  };

  const [firmaTvaIncasare, setFirmaTvaIncasare] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const res = await authFetch("/firma/");
        const items = res?.items || res || [];
        if (items.length > 0) {
          const isFirmaTvaInc = items[0].tva_la_incasare === 1;
          setFirmaTvaIncasare(isFirmaTvaInc);
          setIsPlatitorTva(items[0].platitor_tva === 1);
          setDistribuirePeCentre(!!items[0].distribuire_pe_centre);
          if (isFirmaTvaInc) {
            setField("e_tva_inc", 1);
          }
        }
      } catch (err) {
        console.error("Eroare incarcare config firma:", err);
      }
    })();
  }, []);

  useEffect(() => {
    if (firmaTvaIncasare && value?.e_tva_inc !== 1) {
      setField("e_tva_inc", 1);
    }
  }, [firmaTvaIncasare, value?.e_tva_inc]);

  const [searchParams] = useSearchParams();
  const [showPartModal, setShowPartModal] = useState(false);
  const [partLineIndex, setPartLineIndex] = useState(null);
  const [partLineUid, setPartLineUid] = useState(null);
  const [err, setErr] = useState("");
  // const setField = (k, v) => setDoc((d) => ({ ...d, [k]: v }));
  const accountIdFromUrl = useMemo(() => {
    const v = searchParams.get("account_id");
    const n = v ? parseInt(v, 10) : null;
    return Number.isFinite(n) ? n : null;
  }, [searchParams]);
  const [tipFacturaPicker, setTipFacturaPicker] = useState(false);
  const openTipFacturaPicker = (rowIndex) =>
    setTipFacturaPicker({ show: true, row: rowIndex });
  // normalize date

  const [gestPicker, setGestPicker] = useState({ show: false, row: null });
  const [partPicker, setPartPicker] = useState({ show: false, row: null });
  const [clientPicker, setClientPicker] = useState(false);
  const [showAvizPicker, setShowAvizPicker] = useState(false);
  const [showStornoPicker, setShowStornoPicker] = useState(false);
  const [busy, setBusy] = useState(false);
  const [rows, setRows] = useState([]);
  const [showContactPicker, setShowContactPicker] = useState(false);
  const [showTipFactPicker, setShowTipFactPicker] = useState(false);
  // const [value, onChange?.] = useState(emptyIntrare());

  const [model, setModel] = useState(value ?? emptyIntrare());

  // sus in componenta
  const [showAccPicker, setShowAccPicker] = useState(false);
  const [accLineUid, setAccLineUid] = useState(null);

  // deschidere picker pt o linie (primeste row_uid)
  const openAccountForLine = (row_uid) => {
    setAccLineUid(row_uid);
    setShowAccPicker(true);
  };

  // IMPORTANT: nu reseta uid aici (ca sa nu pierzi selectia daca modalul inchide inainte)
  const closeAccountPicker = () => setShowAccPicker(false);

  const patchLineByUid = (row_uid, patch) => {
    const nextLines = (value.linii || []).map((ln) =>
      ln.row_uid === row_uid ? { ...ln, ...patch } : ln,
    );
    onChange({ ...value, linii: nextLines });
  };

  const onPickAccount = (acc) => {
    const accId = acc?.id ?? acc?.value ?? null;
    if (!accLineUid) return;

    patchLineByUid(accLineUid, {
      bxcont_id: accId,
      bxcont_code: acc?.code ?? null,
      bxcont_name: acc?.denumire ?? acc?.label ?? null,
    });

    setShowAccPicker(false);
    setAccLineUid(null); // resetezi dupa ce ai aplicat
  };

  // const [showPartModal, setShowPartModal] = useState(false);
  // const [partLineIndex, setPartLineIndex] = useState(null);
  useEffect(() => {
    if (value) setModel(value);
  }, [value]);

  const [showTipFactura, setShowTipFactura] = useState(false);
  const [tipFacturaLabel, setTipFacturaLabel] = useState("");
  // const locked = !!value?.bxfinal_bool;
  // daca incarci document (edit) si backend trimite tip_factura_intrare_label
  useEffect(() => {
    console.log("tip_factura_intrare_label", value);
    if (value.tip_factura) {
      setTipFacturaLabel(intrareClassificationLabel(value.tip_factura, value.tip_factura_label));
    }
  }, [value?.tip_factura, value?.tip_factura_label]);

  const openTipFactura = () => setShowTipFactura(true);

  const handlePickTipFactura = (tf) => {
    const label = tf.label || `${tf.cod || ""} • ${tf.denumire || ""}`.trim();

    onChange?.((prev) => ({
      ...prev,
      tip_factura: tf.id,
      tip_factura_label: label,
    }));

    setTipFacturaLabel(label);
    setShowTipFactura(false);
  };

  const [contCcMapByCode, setContCcMapByCode] = useState({}); // { "6022": 3, ... }

  useEffect(() => {
    (async () => {
      const data = await authFetch("/cont_cc_map?limit=10000");
      const items = Array.isArray(data?.items) ? data.items : data;

      const map = {};
      for (const r of items) {
        // presupun r.cont_code exista
        if (r.cont_code && r.cost_center_id)
          map[String(r.cont_code)] = r.cost_center_id;
      }
      setContCcMapByCode(map);
    })();
  }, []);
  const [contCcMapById, setContCcMapById] = useState({});
  const updateLine = (row_uid, patch) => {
    console.log("updateLine loaded", row_uid, patch);
    const linii = (value.linii || []).map((ln) => {
      if (ln.row_uid !== row_uid) return ln;

      const next = { ...ln, ...patch };

      const qty = toNum(next.bxcantitate);
      const price = toNum(next.bxvprice);
      const base = +(qty * price).toFixed(2);
      next.bxvamount = base;

      if (!isPlatitorTva) {
        next.vat_rate = 0;
        next.bxvat_id = 1;
      }

      const vatPercent = isPlatitorTva
        ? next.vat_rate !== undefined && next.vat_rate !== null
          ? toNum(next.vat_rate)
          : 19
        : 0;
      const vat = +((base * vatPercent) / 100).toFixed(2);
      next.bxvatv_amount = vat;

      next.bxtotalv_amount = +(base + vat).toFixed(2);

      return next;
    });

    onChange({
      ...value,
      linii,
    });
    onChange(recalcMaster({ ...value, linii }));
  };

  // const updateLine = (rowUid, patch) => {
  //   onChange?.((prev) => ({
  //     ...prev,
  //     linii: (prev.linii || []).map((ln) =>
  //       ln.row_uid === rowUid ? { ...ln, ...patch } : ln,
  //     ),
  //   }));
  // };

  const [contCcByContId, setContCcByContId] = useState({}); // { 43: [1,2], 35:[7], ... }

  useEffect(() => {
    (async () => {
      try {
        const data = await authFetch("/cont_cc_map?limit=10000");
        const items = Array.isArray(data?.items) ? data.items : data;

        const map = {};
        for (const r of items || []) {
          const contId = Number(r.cont_id ?? r.bxcont_id ?? r.account_id);
          const ccId = Number(r.cost_center_id ?? r.centrucost_id ?? r.cc_id);
          if (!contId || !ccId) continue;

          if (!map[contId]) map[contId] = [];
          map[contId].push(ccId);
        }

        // optional: elimina duplicate + sorteaza
        for (const k of Object.keys(map)) {
          map[k] = Array.from(new Set(map[k])).sort((a, b) => a - b);
        }

        setContCcByContId(map);
        console.log("contCcByContId loaded", map);
      } catch (e) {
        console.error("Eroare load cont_cc_map:", e);
        setContCcByContId({});
      }
    })();
  }, []);

  const defaultAllocFor6xx = (bxcont_id, is6xx) => {
    if (!is6xx || !bxcont_id) return [];

    const list = contCcByContId[Number(bxcont_id)] || [];

    if (list.length === 1) {
      return [{ cost_center_id: list[0], amount: 0, percent: 100 }];
    }

    // 0 sau >1 -> nu auto completezi
    return [];
  };

  const [umById, setUmById] = useState({});
  const handlePickPart = async (p) => {
    console.log("partLineUid", partLineUid, "picked", p);
    if (!partLineUid) return;

    const full = await authFetch(`/bxpart/${p.id}`);

    const um_label =
      `${full.um?.cod ?? ""} — ${full.um?.descriere ?? ""}`.trim();
    const tip = Number(
      full.grupa_produse?.tip_grupa ?? full.bxpart_tip_grupa ?? null,
    );

    const isStocabil = tip === 2;
    const debitId = isStocabil
      ? (full.grupa_produse?.cont_factura_debit_id ?? null)
      : (full.grupa_produse?.contcheltuiala_id ??
        full.grupa_produse?.cont_factura_debit_id ??
        null);
    const bxcont_code = isStocabil
      ? (full.grupa_produse?.bxcont_code ?? null)
      : (full.grupa_produse?.contcheltuiala_code ??
        full.grupa_produse?.bxcont_code ??
        null);
    const is6xx = String(bxcont_code || "").startsWith("6");

    const costAllocPatch = defaultAllocFor6xx(debitId, is6xx);
    console.log("handlePickPart", partLineUid, "picked", p);
    updateLine(partLineUid, {
      bxpart_id: full.id,
      bxpart_label: `${full.cod ?? ""} — ${full.denumire ?? ""}`.trim(),
      bxdescr: `${full.cod ?? ""} — ${full.denumire ?? ""}`.trim(),

      um_label: `${full.um?.cod ?? ""} — ${full.um?.descriere ?? ""}`.trim(),
      bxum_id: full.um?.id ?? null,

      bxpart_tip_grupa: tip || null,

      bxcont_id: debitId,
      bxcont_code,

      bxvat_id: isPlatitorTva ? (full.grupa_produse?.cota_tva_id ?? 4) : 1,
      vat_rate: isPlatitorTva
        ? full.grupa_produse?.bxvat_procent !== undefined &&
          full.grupa_produse?.bxvat_procent !== null
          ? Number(full.grupa_produse.bxvat_procent)
          : 19
        : 0,

      // ✅ aici e cheia
      cost_alloc: costAllocPatch,
    });
    setShowPartModal(false);
    setPartLineUid(null);
  };

  const is6xx = (accCode) =>
    String(accCode || "")
      .trim()
      .startsWith("6");

  const lineTotal = (ln) => {
    const q = Number(ln.bxcantitate ?? ln.qty ?? 0);
    const p = Number(ln.bxvprice ?? ln.price ?? 0);
    // daca tu ai deja total calculat in ln, foloseste-l direct:
    const t = ln.bxtotalv_amount ?? ln.bxvamount ?? q * p;
    const v = Number(t);
    return Number.isFinite(v) ? v : 0;
  };

  const syncAllocAmount = (ln) => {
    console.log("11111111111111111111");
    if (!is6xx(ln?.cont_debit_code ?? ln?.account_code ?? ln?.cont_code))
      return ln;

    const ccId = ln.centrucost_id;
    if (!ccId) return ln;

    const total = lineTotal(ln);

    const alloc = Array.isArray(ln.cost_alloc) ? ln.cost_alloc : [];

    // daca e split (2+), nu modifica
    if (alloc.length >= 2) return ln;

    // 0 alocari => creeaza
    if (alloc.length === 0) {
      // daca total = 0, poti sa nu creezi inca; dar e ok sa creezi si 0
      if (!total) return ln;
      return {
        ...ln,
        cost_alloc: [{ cost_center_id: ccId, percent: 100, amount: total }],
      };
    }

    // 1 alocare => actualizeaza amount si cost_center_id daca e cazul
    const a0 = alloc[0] || {};
    return {
      ...ln,
      cost_alloc: [
        {
          ...a0,
          cost_center_id: ccId,
          percent: 100,
          amount: total,
        },
      ],
    };
  };

  // etichete pentru UI (ca sa nu afisezi doar id)
  const [contactLabel, setContactLabel] = useState("");
  const [tipFactLabel, setTipFactLabel] = useState("");

  const [selectedTipFactura, setselectedTipFactura] = useState(null);

  const [ccModal, setCcModal] = useState({
    show: false,
    idx: -1,
    centers: [],
  });

  const toItems = (data) => {
    if (Array.isArray(data)) return data;
    if (Array.isArray(data?.items)) return data.items;
    return [];
  };

  // const setField = (name, val) => {
  //   onChange?.((prev) => {
  //     const next = { ...prev, [name]: val };
  //     onChange(next); // propaga in Create/Edit
  //     return next; // actualizeaza UI local
  //   });
  // };

  useEffect(() => {
    let alive = true;

    (async () => {
      try {
        const data = await authFetch(`/bxums?skip=0&limit=500`);

        console.log("um", data);
        const items = Array.isArray(data) ? data : data.items || [];
        const map = {};
        for (const u of items) {
          map[u.id] = u.cod || u.descriere || String(u.id);
        }
        if (alive) setUmById(map);
      } catch (e) {
        console.error("Load bxums failed:", e);
      }
    })();

    return () => {
      alive = false;
    };
  }, []);

  const d = (x) => {
    const n = Number(String(x ?? "").replace(",", "."));
    return Number.isFinite(n) ? n : 0;
  };

  // async function openCcForLine(idx) {
  //   const ln = value.linii[idx];
  //   const bxpartId = ln?.bxpart_id;
  //   if (!bxpartId) {
  //     setErr("Alege articolul inainte de impartirea pe centre de cost.");
  //     return;
  //   }

  //   const contId = ln?.bxcont_id ?? null;

  //   // 1) ia mereu centrele
  //   const data = await authFetch(
  //     `/bxcentrucost/pick-cost-centers?bxpart_id=${bxpartId}${
  //       contId ? `&bxcont_id=${contId}` : ""
  //     }`,
  //   );

  //   // 2) abia apoi deschide modalul
  //   setCcModal({
  //     show: true,
  //     idx,
  //     centers: data.items || [],
  //     total: Number(ln?.bxvamount || 0),
  //     initialSplit: Array.isArray(ln?.cost_alloc) ? ln.cost_alloc : [],
  //   });
  // }

  // const toNum = (x) => {
  //   const n = Number(String(x ?? "").replace(",", "."));
  //   return Number.isFinite(n) ? n : 0;
  // };

  const openCcForLine = async (ln) => {
    const row_uid = ln.row_uid; // ✅ UID stabil
    const contId = ln.cont_factura_debit_id ?? ln.bxcont_id;
    const total = toNum(ln?.bxvamount);

    console.log("openCcForLine", row_uid, total);

    if (!contId) {
      setErr?.("Linia nu are cont de debit.");
      return;
    }
    if (total <= 0) {
      setErr?.("Baza este 0, nu pot aloca pe centre de cost.");
      return;
    }

    const data = await authFetch(
      `/cont_cc_map?cont_id=${contId}&skip=0&limit=200`,
    );
    let centers = data?.items || [];

    if (centers.length === 0) {
      try {
        const allCc = await authFetch(`/bxcentrucost/?skip=0&limit=200`);
        centers = (allCc?.items || []).map((cc) => ({
          cost_center_id: cc.id,
          cc_code: cc.code,
          cc_name: cc.name,
          cc_label: `${cc.code || ""}   ${cc.name || ""}`,
        }));
      } catch (errCc) {
        console.error("Failed to load fallback cost centers:", errCc);
      }
    }

    if (centers.length === 0) {
      setErr?.("Nu exista centre de cost definite in sistem.");
      return;
    }

    // helper: update dupa row_uid, nu idx
    const updateLineByUid = (uid, patch) => {
      onChange?.({
        ...value,
        linii: (value.linii || []).map((x) =>
          x.row_uid === uid ? { ...x, ...patch } : x,
        ),
      });
    };

    if (centers.length === 1) {
      updateLineByUid(row_uid, {
        cost_alloc: [
          { cost_center_id: Number(centers[0].cost_center_id), amount: total },
        ],
      });
      //return; // ✅ la 1 mapare nu mai deschizi modalul
    }

    // >=2 => modal split
    setCcModal({
      show: true,
      row_uid: ln.row_uid, // ✅ in loc de idx
      centers,
      total,
      initialSplit: Array.isArray(ln?.cost_alloc) ? ln.cost_alloc : [],
    });
  };

  useEffect(() => {
    console.log("IntrareForm value.tip_factura:", value?.tip_factura);
  }, [value?.tip_factura]);

  useEffect(() => {
    if (!initial) return;
    const d = { ...emptyIntrare(), ...initial };

    if (d.doc_date) d.doc_date = String(d.doc_date).slice(0, 10) + "T00:00:00";

    // // normalize lines
    // d.linii = (d.linii || []).map((ln) => ({
    //   ...emptyLine(),
    //   ...ln,
    //   uid: ln?.uid || makeUid(),
    //   cost_alloc: Array.isArray(ln?.cost_alloc) ? ln.cost_alloc : [],
    //   bxgestiune_id: ln?.bxgestiune_id ?? null,
    //   bxpart_label: ln?.bxpart_label ?? "",
    //   stock_total: ln?.stock_total ?? 0,
    //   loadingAvail: false,
    // }));

    d.linii = (d.linii || []).map((ln) => {
      const n = {
        ...emptyLine(),
        ...ln,
        uid: ln?.uid || makeUid(),
        bxgestiune_id: ln?.bxgestiune_id ?? null,
        bxpart_label: ln?.bxpart_label ?? "",
        stock_total: ln?.stock_total ?? 0,
        loadingAvail: false,
      };

      // ✅ cost_alloc din n (dupa merge), nu din ln
      n.cost_alloc = Array.isArray(n?.cost_alloc) ? n.cost_alloc : [];

      return n;
    });

    // normalize date
    if (d.doc_date) d.doc_date = String(d.doc_date).slice(0, 10) + "T00:00:00";

    onChange?.(d);

    if (d.contact_id)
      setSelectedContact({
        value: d.contact_id,
        label: `#${d.contact_id}`,
      });
    else setSelectedContact(null);

    if (d.tip_factura)
      setselectedTipFactura({
        value: d.tip_factura,
        label: intrareClassificationLabel(d.tip_factura, d.tip_factura_label),
      });
    else setselectedTipFactura(null);
  }, [initial]);

  /* ===============================
     TIP FACTURA IESIRE DROPDOWN
  ================================ */
  const loadTipFacturaOptions = async (inputValue, _loaded, additional) => {
    const page = additional?.page ?? 1;
    const q = (inputValue || "").trim();

    const data = await [
      `/tip_factura_intrare/?skip=${(page - 1) * 10}&limit=10&q=${encodeURIComponent(q)}`,
    ];

    const items = data?.items || data || [];
    const total = data?.total ?? null;

    const options = items
      .map((it) => ({
        value: it.id ?? it.tip_factura_intrare_id ?? it.bxid,
        label:
          it.denumire ??
          it.name ??
          it.bxdenumire ??
          `#${it.id ?? it.tip_factura_intrare_id ?? it.bxid}`,
        raw: it,
      }))
      .filter((o) => o.value);

    const hasMore = total != null ? page * 10 < total : options.length === 10;
    return { options, hasMore, additional: { page: page + 1 } };
  };

  const handleTipFacturaChange = (opt) => {
    console.log("HANDLE TIP FACTURA CHANGE:", opt);
    // opt: { value, label } din picker
    const updateMaster = (patch) => {
      const next = recalcMaster({ ...value, ...patch });
      onChange?.(next); // ✅ UI se actualizeaza imediat
      onChange(next); // ✅ propaga spre parinte
    };

    openTipFacturaPicker(false);
  };

  useEffect(() => {
    if (!accountIdFromUrl) return;
    console.log("IntrareForm → account_id din URL:", accountIdFromUrl);

    // pune contul din URL doar daca e diferit
    if (Number(value?.bxcont_id) !== accountIdFromUrl) {
      updateMaster({ bxcont_id: accountIdFromUrl });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountIdFromUrl]);

  // <Link to={`/intrare/${currentAccountId}`}>Intrare</Link>;  - eroare la edit

  // === incarcam optiunea selectata (edit) daca nu e in pagina curenta ===

  useEffect(() => {
    // TODO: schimba URL-ul cu endpoint-ul tau real
    fetch("/api/tip_factura_intrare/")
      .then((res) => res.json())
      .then((data) => {
        // Ma astept la ceva de forma:
        // [{ bxid: 1, tip_factura: "Factura" }, ...]
        setTipFacturaOptions(data);
      })
      .catch((err) => {
        console.error("Eroare la incarcarea tipurilor de factura:", err);
      });
  }, []);

  useEffect(() => {
    let alive = true;

    const loadSelected = async (id) => {
      if (!id) {
        if (alive) setSelectedContact(null);
        return;
      }
      try {
        const c = await authFetch(`/contacte/${id}`);
        const option = {
          value: c.id,
          label: `${c.bxdenumire}${c.bxcodfiscal ? ` (${c.bxcodfiscal})` : ""}`,
        };
        if (alive) setSelectedContact(option);
      } catch {
        // fallback: folosim contact_name daca a venit din GET /intrare/{id}
        const label =
          value?.contact_name || value?.contact?.bxdenumire || `Contact #${id}`;
        if (alive) setSelectedContact({ value: id, label });
      }
    };

    if (value?.contact_id && selectedContact?.value !== value.contact_id) {
      loadSelected(value.contact_id);
    }
    if (!value?.contact_id && selectedContact) {
      setSelectedContact(null);
    }

    return () => {
      alive = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value?.contact_id]);

  // === init selected part for each line when editing (by id) ===
  useEffect(() => {
    let alive = true;

    const ensureSelected = async (idx, id) => {
      if (!id) {
        if (alive) {
          setSelectedPartByIndex((m) => {
            const cp = { ...m };
            delete cp[idx];
            return cp;
          });
        }
        return;
      }

      // daca e deja selectat corect, nu mai facem nimic
      if (selectedPartByIndex[idx]?.value === id) return;

      // incearca cache-ul mai intai
      let p = partCache.current.get(id);
      if (!p) {
        try {
          p = await authFetch(`/bxpart/${id}`);
          if (p?.id) partCache.current.set(p.id, p);
        } catch {
          // fallback la eticheta generica
          p = { id, cod: `#${id}`, denumire: "" };
        }
      }
      if (!alive) return;

      setSelectedPartByIndex((m) => ({
        ...m,
        [idx]: {
          value: p.id,
          label: `${p.cod ?? ""} — ${p.denumire ?? ""}`.trim(),
          um_id: p?.um?.id ?? p?.um_id ?? null,
        },
      }));
    };

    (value.linii || []).forEach((ln, idx) => {
      if (ln?.bxpart_id) ensureSelected(idx, ln.bxpart_id);
    });

    return () => {
      alive = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value.linii]);

  // evidentiere text cautat in optiuni
  const HighlightedOption = (props) => {
    const q = (props.selectProps.inputValue || "").trim();
    const label = props.data.label || "";
    const parts = q ? label.split(new RegExp(`(${q})`, "i")) : [label];
    return (
      <components.Option {...props}>
        {parts.map((p, i) =>
          q && p.toLowerCase() === q.toLowerCase() ? (
            <mark key={i}>{p}</mark>
          ) : (
            <span key={i}>{p}</span>
          ),
        )}
      </components.Option>
    );
  };

  const [supplierAcc, setSupplierAcc] = useState(null); // {id, code, denumire, bxvaluta_id}
  const requiredDocumentType = !value?.id && (fixedDocumentType === "Aviz" ||
    (Number(supplierAcc?.id) === Number(value?.bxcont_id) && String(supplierAcc?.code || "").startsWith("408"))) ? "Aviz" : null;

  useEffect(() => {
    if (!requiredDocumentType || (value.tip_document === "Aviz" && Number(value.tip_factura) === 2)) return;
    onChange?.(prev => changeIntrareDocument(prev, "Aviz"));
  }, [requiredDocumentType, value.tip_document, value.tip_factura, onChange]);

  useEffect(() => {
    const id = value?.bxcont_id;
    if (!id) {
      setSupplierAcc(null);
      return;
    }

    (async () => {
      try {
        const acc = await authFetch(`/accounts/${id}`);
        setSupplierAcc({
          id: acc.id,
          code: acc.code ?? acc.bxcod ?? acc.bxcont_code ?? "",
          denumire: acc.name ?? acc.denumire ?? acc.bxdenumire ?? "",
          bxvaluta_id: acc.bxvaluta_id ?? acc.valuta_id ?? 1,
        });
      } catch (e) {
        setSupplierAcc({ id, code: "", denumire: "", bxvaluta_id: 1 });
      }
    })();
  }, [value?.bxcont_id]);

  const isForeignCurrency = supplierAcc && supplierAcc.bxvaluta_id !== 1;

  const onPickContact = async (c) => {
    // c: { id, label, raw } (ex: "RX ATELIER SRL")
    const patch = {
      contact_id: c.id,
      contact_label: c.label,
    };

    if (firmaTvaIncasare) {
      patch.e_tva_inc = 1;
    } else {
      const cuiRaw = c.raw?.bxcodfiscal || "";
      const cuiDigits = cuiRaw.replace(/[^0-9]/g, "");
      if (cuiDigits) {
        try {
          const docDateStr = value.bxdoc_date
            ? value.bxdoc_date.substring(0, 10)
            : new Date().toISOString().substring(0, 10);
          const { data } = await api.post("/anaf/lookup", {
            cui: cuiDigits,
            data: docDateStr,
          });
          const isTvaInc =
            data.statusTvaIncasare === true ||
            data.statusTvaIncasare === "true" ||
            String(data.statusTvaIncasare).toUpperCase() === "DA" ||
            String(data.statusTvaIncasare).toUpperCase() === "YES" ||
            String(data.statusTvaIncasare).toUpperCase() === "1";

          patch.e_tva_inc = isTvaInc ? 1 : 0;
        } catch (err) {
          console.error("Eroare preluare status TVA incasare ANAF:", err);
        }
      }
    }

    updateMaster(patch);
    setContactLabel(c.label || "");
    setClientPicker(false);
  };

  const onPickTipFact = (t) => {
    // t: { id, label } sau { value, label } depinde cum alegi
    // daca in model ai tip_factura numeric:
    updateMaster({ tip_factura: t.id }); // sau t.value
    setTipFactLabel(t.label || "");
    setShowTipFactPicker(false);
  };

  // functie de incarcare paginata pentru contacte
  const loadOptions = useCallback(async (inputValue, _loaded, additional) => {
    const page = additional?.page ?? 1;
    const q = (inputValue || "").trim();
    const skip = (page - 1) * LIMIT;

    try {
      // recomandat: terminati cu "/" ca sa nu apara redirecturi care incurca CORS
      const data = await authFetch(
        `/contacte/?search=${encodeURIComponent(q)}&skip=${skip}&limit=${LIMIT}`,
      );

      // suporta ambele forme de raspuns: lista simpla SAU {items,total}
      const items = Array.isArray(data)
        ? data
        : Array.isArray(data?.items)
          ? data.items
          : [];

      const total =
        typeof data?.total === "number"
          ? data.total
          : typeof data?.count === "number"
            ? data.count
            : undefined;

      const options = items.map((c) => ({
        value: c.id,
        label: `${c.bxdenumire}${c.bxcodfiscal ? ` (${c.bxcodfiscal})` : ""}`,
      }));

      const hasMore =
        typeof total === "number"
          ? skip + items.length < total
          : items.length === LIMIT; // fallback cand API nu da total

      return {
        options,
        hasMore,
        additional: { page: page + 1 },
      };
    } catch (err) {
      console.error("loadOptions error:", err);
      return { options: [], hasMore: false, additional: { page } };
    }
  }, []);

  useEffect(() => {
    let alive = true;

    async function hydrateParts() {
      console.log("hydrate --- ", value);
      if (!value?.linii?.length) return;

      for (let idx = 0; idx < value.linii.length; idx++) {
        const ln = value.linii[idx];
        const id = ln.bxpart_id;
        if (!id) continue;

        // daca UM lipseste, hidratam
        if (ln.bxum_id != null && ln.bxpart_label) continue;

        let p = partCache.current.get(id);
        if (!p) {
          try {
            p = await authFetch(`/bxpart/${id}`); // trebuie sa returneze JSON
            if (p?.id) partCache.current.set(p.id, p);
          } catch {
            p = { id, cod: `#${id}`, denumire: "", um: null };
          }
        }
        if (!alive) return;

        const label = `${p.cod ?? ""} — ${p.denumire ?? ""}`.trim();
        const umId = p.um?.id ?? null;

        // DEBUG (lasa 1 minut ca sa vezi)
        console.log("HYDRATE", idx, "part", id, "um", p.um, "umId", umId);

        updateLine(idx, {
          bxpart_label: label,
          bxum_id: umId,
          um_label: p.um?.cod ?? "",
        });
      }
    }

    hydrateParts();
    return () => {
      alive = false;
    };
  }, [value?.id, value?.linii?.length]);

  const additional = useMemo(() => ({ page: 1 }), []);
  const loadPartOptions = useCallback(
    async (inputValue, _loaded, additional) => {
      const page = additional?.page ?? 1;
      const q = (inputValue || "").trim();
      const skip = (page - 1) * PART_LIMIT;

      try {
        // suporta atat lista simpla cat si {items,total}
        const data = await authFetch(
          `/bxpart/?search=${encodeURIComponent(
            q,
          )}&skip=${skip}&limit=${PART_LIMIT}&tip_grupa_in=1,2`,
        );

        const items = Array.isArray(data)
          ? data
          : Array.isArray(data?.items)
            ? data.items
            : [];
        const total =
          typeof data?.total === "number"
            ? data.total
            : typeof data?.count === "number"
              ? data.count
              : undefined;

        // populati cache-ul
        items.forEach((it) => partCache.current.set(it.id, it));

        const options = items.map((p) => ({
          value: p.id,
          label: `${p.cod ?? ""} — ${p.denumire ?? ""}`.trim(),
          um_id: p.um_id ?? null,

          bxdescr: p.denumire,
        }));

        const hasMore =
          typeof total === "number"
            ? skip + items.length < total
            : items.length === PART_LIMIT;

        return {
          options,
          hasMore,
          additional: { page: page + 1 },
        };
      } catch (err) {
        console.error("loadPartOptions error:", err);
        return { options: [], hasMore: false, additional: { page } };
      }
    },
    [],
  );

  // const handlePartChange = (rowUid, opt) => {
  //   console.log("handlePartChange opt11100=", opt);
  //   if (!opt) {
  //     setSelectedPartByIndex((m) => ({ ...m, [rowUid]: undefined }));
  //     updateLine(rowUid, {
  //       bxpart_id: 0,
  //       bxum_id: null,
  //       bxdescr: "",
  //       cost_alloc: [],
  //     });
  //     console.log("handlePartChange opt111=", opt);
  //     return;
  //   }

  //   const partId = opt.value ?? opt.id; // ✅ compatibil
  //   const umId = opt.um_id ?? opt.um?.id ?? null; // ✅ compatibil
  //   console.log("handlePartChange opt2222=", opt);
  //   setSelectedPartByIndex((m) => ({
  //     ...m,
  //     [rowUid]: {
  //       value: partId,
  //       label: opt.label ?? `${opt.cod ?? ""} — ${opt.denumire ?? ""}`.trim(),
  //       um_id: umId,
  //       bxcont_code: opt.bxcont_code.trim(),
  //       tip_grupa: opt.tip_grupa ?? opt.bxpart_tip_grupa ?? null,
  //       cont_factura_debit_id:
  //         opt.cont_factura_debit_id ??
  //         opt.grupa_produse?.cont_factura_debit_id ??
  //         null,
  //     },
  //   }));

  //   const patch = {
  //     bxpart_id: partId, // ✅ se seteaza produsul
  //     bxum_id: umId, // ✅ se seteaza UM
  //   };

  //   // descriere doar daca e goala in linia curenta
  //   const curDescr = (value?.linii?.[rowUid]?.bxdescr ?? "").trim(); // daca ai `value` in scope
  //   if (!curDescr) {
  //     patch.bxdescr =
  //       opt.bxdescr ||
  //       opt.label ||
  //       `${opt.cod ?? ""} ${opt.denumire ?? ""}`.trim();
  //   }

  //   // cand schimbi produsul, alocarile vechi nu mai sunt valide
  //   patch.cost_alloc = [];

  //   updateLine(rowUid, patch); // ✅ AICI era problema: nu aplicai patch-ul
  // };

  const handlePartChange = (rowUid, opt) => {
    console.log("handlePartChange opt =", opt);

    if (!opt) {
      setSelectedPartByIndex((m) => ({ ...m, [rowUid]: undefined }));
      updateLine(rowUid, {
        bxpart_id: 0,
        bxum_id: null,
        bxdescr: "",
        cost_alloc: [],
      });
      return;
    }

    const raw = opt.raw ?? opt;

    const partId = raw.id ?? opt.value ?? opt.id;
    const umId = raw.um?.id ?? raw.um_id ?? null;

    const bxcontCode =
      raw.grupa_produse?.bxcont_code ?? raw.bxcont_code ?? null;
    const contDebit =
      raw.grupa_produse?.cont_factura_debit_id ??
      raw.cont_factura_debit_id ??
      null;
    const tipGrupa = raw.tip_grupa ?? raw.bxpart_tip_grupa ?? null;

    setSelectedPartByIndex((m) => ({
      ...m,
      [rowUid]: {
        value: partId,
        label: opt.label ?? `${raw.cod ?? ""} — ${raw.denumire ?? ""}`.trim(),
        um_id: umId,
        bxcont_code: bxcontCode,
        tip_grupa: tipGrupa,
        cont_factura_debit_id: contDebit,
      },
    }));

    const curLine = (value?.linii || []).find((ln) => ln.row_uid === rowUid);
    const curDescr = (curLine?.bxdescr ?? "").trim();

    const patch = {
      bxpart_id: partId,
      bxum_id: umId,
      // daca ai campuri in linie pentru debit: seteaza-le aici
      cont_factura_debit_id: contDebit,
      bxcont_code: bxcontCode,
      cost_alloc: [], // reset
    };

    if (!curDescr) {
      patch.bxdescr =
        opt.label ?? `${raw.cod ?? ""} ${raw.denumire ?? ""}`.trim();
    }

    updateLine(rowUid, patch);
  };

  // ==== calcule document ====
  const calcLine = (line) => {
    const qty = parseNumber(line.bxcantitate);
    const price = parseNumber(line.bxvprice);
    const amount = +(qty * price).toFixed(2);
    const vatRate = 0.19;
    const vat = +(amount * vatRate).toFixed(2);
    const total = +(amount + vat).toFixed(2);
    return {
      ...line,
      bxvamount: amount,
      bxvatv_amount: vat,
      bxtotalv_amount: total,
    };
  };

  const recalcMaster = (m) => {
    const sum = (m.linii || []).reduce(
      (acc, ln) => acc + parseNumber(ln.bxtotalv_amount),
      0,
    );
    return { ...m, bxgvalue: sum.toFixed(2), bxsold: sum.toFixed(2) };
  };

  const updateMaster = (patch) =>
    onChange(recalcMaster({ ...value, ...patch }));

  useEffect(() => {
    if (supplierAcc && supplierAcc.bxvaluta_id) {
      const patch = {};
      if (supplierAcc.bxvaluta_id !== value.bxvaluta_id) {
        patch.bxvaluta_id = supplierAcc.bxvaluta_id;
      }
      if (supplierAcc.bxvaluta_id !== 1 && value.e_tva_inc !== 0) {
        patch.e_tva_inc = 0;
      }
      if (Object.keys(patch).length > 0) {
        updateMaster(patch);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [supplierAcc, value.bxvaluta_id, value.e_tva_inc]);

  // Track initial mount to prevent overwriting existing document rates on load
  const isInitialMount = useRef(true);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      if (value.id) {
        return;
      }
    }

    const fetchBnrRates = async () => {
      const valutaId = value.bxvaluta_id;
      if (!valutaId) return;

      if (parseInt(valutaId) === 1) {
        if (value.bxvaluta_curs !== "1.0000" || value.bxcurs_invoice !== null) {
          onChange({
            ...value,
            bxvaluta_curs: "1.0000",
            bxcurs_invoice: null,
          });
        }
        return;
      }

      let newBnrCurs = value.bxvaluta_curs;
      if (value.bxinput_date) {
        try {
          const dateStr = value.bxinput_date.substring(0, 10);
          const res = await api.get(`/bxvaluta/curs/fetch`, {
            params: { valuta_id: valutaId, date: dateStr }
          });
          if (res.data && res.data.rate !== undefined) {
            newBnrCurs = parseFloat(res.data.rate).toFixed(4);
          }
        } catch (err) {
          console.error("Eroare la preluare curs BNR:", err);
        }
      }

      let newInvoiceCurs = value.bxcurs_invoice;
      if (value.bxdoc_date) {
        try {
          const dateStr = value.bxdoc_date.substring(0, 10);
          const res = await api.get(`/bxvaluta/curs/fetch`, {
            params: { valuta_id: valutaId, date: dateStr }
          });
          if (res.data && res.data.rate !== undefined) {
            newInvoiceCurs = parseFloat(res.data.rate).toFixed(4);
          }
        } catch (err) {
          console.error("Eroare la preluare curs factura:", err);
        }
      }

      if (value.bxvaluta_curs !== newBnrCurs || value.bxcurs_invoice !== newInvoiceCurs) {
        onChange({
          ...value,
          bxvaluta_curs: newBnrCurs,
          bxcurs_invoice: newInvoiceCurs,
        });
      }
    };

    fetchBnrRates();
  }, [value.bxvaluta_id, value.bxdoc_date, value.bxinput_date]);

  // date handlers
  const setBxdocDate = (d) => {
    if (!d) {
      updateMaster({
        bxdoc_date: null,
        bxinput_date: null,
        bxdatascadenta: null,
      });
      return;
    }
    const dateVal = ymdToISODateTime(toYMD(d), "00", "00");
    const dueDate = new Date(d);
    dueDate.setDate(dueDate.getDate() + 30);
    const dueDateVal = ymdToISODateTime(toYMD(dueDate), "00", "00");
    updateMaster({
      bxdoc_date: dateVal,
      bxinput_date: dateVal,
      bxdatascadenta: dueDateVal,
    });
  };
  const setBxinputDate = (d) =>
    updateMaster({ bxinput_date: ymdToISODateTime(toYMD(d), "00", "00") });
  const setBxdatascadenta = (d) =>
    updateMaster({ bxdatascadenta: ymdToISODateTime(toYMD(d), "00", "00") });

  // linii
  const addLine = () => {
    const first = value.linii?.[0] || {
      row_uid: crypto.randomUUID(), // 👈 AICI
      bxcomanda_id: null,
      bxpart_id: 0,
      bxgestiune_id: 0,
      bxum_id: 1,
      bxcantitate: 1,
      bxvprice: 0,
      bxvamount: 0,
      bxvatv_amount: 0,
      bxtotalv_amount: 0,
      bxvat_id: 1,
      bxdescr: "",
      bxcont_id: value?.bxcont_id ?? 1,
    };

    const newLn = {
      // ...first,
      row_uid: crypto.randomUUID(), // 👈 AICI
      id: undefined,
      bxpart_id: 0,
      bxgestiune_id: 0,
      bxcantitate: 1,
      bxvprice: 0,
      bxvamount: 0,
      bxvatv_amount: 0,
      bxtotalv_amount: 0,
      bxvat_id: isPlatitorTva ? 4 : 1,
      vat_rate: isPlatitorTva ? 19 : 0,
    };

    onChange?.((prev) =>
      recalcMaster({
        ...prev,
        linii: [...(prev.linii || []), newLn],
      }),
    );
  };

  const handlePickAviz = async (avizId) => {
    try {
      const aviz = await authFetch(`/intrare/${avizId}/aviz-remaining`);
      if (!aviz || !aviz.linii) return;
      if (!aviz.linii.length) throw new Error("Avizul nu mai are cantități disponibile.");
      if ((value.linii || []).some(ln => ln.bxpart_id && !ln.source_aviz_line_id)) {
        throw new Error("Facturează avizele într-o factură separată de achizițiile fără aviz.");
      }
      if (aviz.linii.some(ln => Number(ln.bxvaluta_id) !== Number(value.bxvaluta_id || 1))) {
        throw new Error("Selectează pe factură aceeași monedă ca pe aviz.");
      }
      const selectedSources = new Set((value.linii || []).map(ln => ln.source_aviz_line_id));

      const importedLines = aviz.linii.filter(ln => !selectedSources.has(ln.source_aviz_line_id)).map((ln) => {
        const qty = Number(ln.remaining_qty) || 0;
        const price = Number(ln.bxvprice) || 0;
        const base = +(qty * price).toFixed(2);
        const vatPercent =
          ln.vat_rate !== undefined && ln.vat_rate !== null
            ? Number(ln.vat_rate)
            : NaN;
        if (!Number.isFinite(vatPercent) || !ln.bxvat_id) throw new Error("Cota TVA lipsește din aviz. Corectează avizul înainte de facturare.");
        const vat = +((base * vatPercent) / 100).toFixed(2);
        const total = +(base + vat).toFixed(2);

        return {
          row_uid: crypto.randomUUID(),
          source_aviz_line_id: ln.source_aviz_line_id,
          bxpart_id: ln.bxpart_id,
          bxdescr: ln.bxdescr || "",
          bxum_id: ln.bxum_id ?? 1,
          bxcantitate: qty,
          bxvprice: price,
          bxvamount: base,
          bxvatv_amount: vat,
          bxtotalv_amount: total,
          bxvat_id: ln.bxvat_id,
          vat_rate: vatPercent,
          bxcont_id: ln.bxcont_id,
          bxcont_code: ln.bxcont_code || "",
          data_expirare: ln.data_expirare || null,
          bxpart_label: ln.bxpart_label || "",
        };
      });

      // Daca liniile actuale sunt goale sau contin o singura linie necompletata, le inlocuim
      const isCurrentEmpty =
        !value.linii ||
        value.linii.length === 0 ||
        (value.linii.length === 1 && !value.linii[0].bxpart_id);

      const newLinii = isCurrentEmpty
        ? importedLines
        : [...value.linii, ...importedLines];

      onChange(
        recalcMaster({
          ...value,
          linii: newLinii,
        }),
      );

      toast.success(
        `S-au preluat ${importedLines.length} repere din avizul selectat.`,
      );
    } catch (e) {
      toast.error(`Eroare la preluarea avizului: ${e.message || e}`);
    }
  };

  const handlePickStorno = (item, qtyToStorno) => {
    const newUid = crypto.randomUUID();
    const qty = -qtyToStorno;
    const price = Number(item.price) || 0;
    const base = +(qty * price).toFixed(2);
    const vatPercent =
      item.vat_rate !== undefined && item.vat_rate !== null
        ? Number(item.vat_rate)
        : 19;
    const vat = +((base * vatPercent) / 100).toFixed(2);
    const total = +(base + vat).toFixed(2);

    const newLn = {
      row_uid: newUid,
      id: undefined,
      bxpart_id: item.bxpart_id,
      bxpart_label: `${item.part_code} • ${item.part_name}`,
      bxdescr: `Storno NIR nr. ${item.doc_no} (Lot: ${item.nr_lot || "standard"})`,
      bxum_id: item.bxum_id || 1,
      bxgestiune_id: item.bxgestiune_id,
      bxcantitate: qty,
      bxvprice: price,
      bxvamount: base,
      bxvatv_amount: vat,
      bxtotalv_amount: total,
      bxvat_id: item.bxvat_id ?? 4,
      vat_rate: vatPercent,
      bxstocin_id: item.stocin_id,
      data_expirare: null,
      cost_alloc: [],
    };

    const isCurrentEmpty =
      !value.linii ||
      value.linii.length === 0 ||
      (value.linii.length === 1 && !value.linii[0].bxpart_id);

    const newLinii = isCurrentEmpty ? [newLn] : [...value.linii, newLn];

    onChange(
      recalcMaster({
        ...value,
        linii: newLinii,
      }),
    );
  };

  const removeLine = (rowUid) => {
    onChange((prev) => ({
      ...prev,
      linii: (prev.linii || []).filter((ln) => ln.row_uid !== rowUid),
    }));
  };

  // const updateLine = (idx, patch) => {
  //   console.log("valoare linie patch", patch);
  //   onChange?.((prev) => {
  //     const linii = (prev.linii || []).map((ln, i) =>
  //       i === idx ? { ...ln, ...patch } : ln,
  //     );
  //     console.log("valoare linie patch11", patch);
  //     const linii2 = linii.map((ln, i) => {
  //       if (i !== idx) return ln;

  //       const qtyN = parseNumber(ln.bxcantitate);
  //       const priceN = parseNumber(ln.bxvprice);
  //       if (!Number.isFinite(qtyN) || !Number.isFinite(priceN)) return ln;

  //       // IMPORTANT: calcLine sa nu “scape” cost_alloc
  //       const lnCalcRaw = calcLine(ln);

  //       const lnCalc = {
  //         ...ln, // pastreaza tot ce era (inclusiv cost_alloc)
  //         ...lnCalcRaw, // suprascrie doar campurile calculate
  //       };

  //       return lnCalc;
  //     });

  //     // recalc master
  //     const next0 = recalcMaster({ ...prev, linii: linii2 });

  //     // IMPORTANT: sync dupa recalcMaster, pe linia finala
  //     const linii3 = (next0.linii || []).map((ln, i) =>
  //       i === idx ? syncAllocAmount(ln) : ln,
  //     );

  //     const next = { ...next0, linii: linii3 };
  //     return next;
  //   });
  // };

  // const updateLine = (idx, patch) => {
  //   const linii = value.linii.map((ln, i) => {
  //     if (i !== idx) return ln;

  //     const merged = { ...ln, ...patch };

  //     // ✅ nu lasa cost_alloc sa devina null/undefined
  //     if (!Array.isArray(merged.cost_alloc)) {
  //       merged.cost_alloc = Array.isArray(ln.cost_alloc) ? ln.cost_alloc : [];
  //     }

  //     return calcLine(merged);
  //   });

  //   onChange(recalcMaster({ ...value, linii }));
  // };

  const currentLine =
    ccModal.idx >= 0 && value.linii?.[ccModal.idx]
      ? value.linii[ccModal.idx]
      : null;

  useEffect(() => {
    const i = ccModal.idx;
    if (i >= 0) {
      console.log("LINE cost_alloc NOW:", value.linii?.[i]?.cost_alloc);
    }
  }, [value.linii, ccModal.idx]);
  const handleChange = (v) => {
    console.log("PARENT IN cost_alloc:", v.linii?.[2]?.cost_alloc);
    onChange?.(v);
  };
  // const testSetTipFactura = () => {
  //   onChange?.((prev) => ({
  //     ...prev,
  //     tip_factura_intrare_id: 99,
  //     tip_factura_intrare_label: "TEST DIRECT",
  //   }));
  // };

  const toNum = (v) => {
    if (v === null || v === undefined) return 0;
    if (typeof v === "number") return Number.isFinite(v) ? v : 0;
    const s = String(v).trim().replace(/\s+/g, "").replace(",", ".");
    const n = Number(s);
    return Number.isFinite(n) ? n : 0;
  };

  const openPartForLine = (ln) => {
    console.log("openPartForLine", ln);
    setPartLineUid(ln);
    setShowPartModal(true);
  };
  const onPickPart = (idx, opt) => {
    const tip = Number(opt.tip_grupa ?? opt.tip_grupa_produse ?? 0);

    // debit default pentru factura (IMPORTANT)
    const debitId = opt.cont_factura_debit_id ?? null;

    updateLine(idx, {
      bxpart_id: opt.value,
      bxpart_label: opt.label,
      bxum_id: opt.um_id ?? null,
      bxpart_tip_grupa: tip || null,
      bxcont_code: opt.bxcont_code,
      // sursa de adevar pentru debit:
      cont_factura_debit_id: debitId,
      // daca inca ai bxcont_id in model, tine-l sincronizat:
      bxcont_id: debitId,

      // cand schimbi produsul, alocarile vechi nu mai sunt valide
      cost_alloc: [],
    });
    console.log("valoare linie opt", opt);
    // optional: daca e 6xx si cont_cc_map are exact 1 rand,
    // aici poti auto-popula cost_alloc (dar eu as face asta in backend la SAVE)
  };

  // const sumAlloc = (ln) =>
  //   (ln.cost_alloc || []).reduce((s, a) => s + toNum(a.amount), 0);

  // // alege corect “valoarea liniei” (la tine pare bxvamount)
  // const lineValue = (ln) => toNum(ln.amount ?? ln.bxvamount ?? ln.bxvamount);

  // const diffAlloc = (ln) => lineValue(ln) - sumAlloc(ln);
  // console.log("valoare linie", lineValue(ln));
  // console.log("valoare sumAlloc", sumAlloc(ln));
  // //const isAllocOk = (ln, eps = 0.01) => Math.abs(diffAlloc(ln)) <= eps;

  // const isAllocOk = (ln) => {
  //   const total = Number(ln?.value ?? 0); // sau formula ta reala
  //   const allocSum = (ln?.cost_alloc || []).reduce(
  //     (s, r) => s + Number(r.amount ?? 0),
  //     0,
  //   );

  //   return Math.abs(total - allocSum) < 0.01; // toleranta 1 ban
  // };

  return (
    <Form
      autoComplete="off"
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit?.();
      }}
    >
      <input
        type="text"
        name="dummy1"
        style={{ display: "none" }}
        autoComplete="off"
      />
      <input
        type="password"
        name="dummy2"
        style={{ display: "none" }}
        autoComplete="off"
      />
      <Row className="g-3">
        <Col md={2}>
            <Form.Group controlId="tip_document">
              <Form.Label>Tip Document</Form.Label>
              <Form.Select
                value={value.tip_document || "Factura"}
                onChange={(e) => {
                  if (requiredDocumentType) return;
                  const tip = e.target.value;
                  onChange?.((prev) => changeIntrareDocument(prev, tip));
                }}
                disabled={locked || !!requiredDocumentType}
              >
                <option value="Factura">Factura</option>
                <option value="Proforma">Proforma</option>
                <option value="Aviz">Aviz</option>
                <option value="Bon fiscal">Bon fiscal</option>
                <option value="Borderou">Borderou</option>
              </Form.Select>
              {requiredDocumentType && <Form.Text>Tipul documentului este stabilit de meniul Avize furnizori.</Form.Text>}
            </Form.Group>
          </Col>
          <Col md={2}>
          <Form.Group controlId="bxdoc_no">
            <Form.Label>Doc No</Form.Label>
            <Form.Control
              name={`bxdoc_no_${uniq}`}
              readOnly
              autoComplete="off"
              onFocus={(e) => {
                if (!locked) e.target.readOnly = false;
              }}
              disabled={locked}
              value={value.bxdoc_no || ""}
              onChange={(e) => setField("bxdoc_no", e.target.value)}
            />
          </Form.Group>
        </Col>

        <Col md="auto">
          <Form.Group controlId="bxdoc_date">
            <Form.Label>Data Doc</Form.Label>
            <InputGroup size="sm" className="w-auto">
              <DatePicker
                selected={fromISOToDate(value.bxdoc_date)}
                onChange={setBxdocDate}
                dateFormat="dd.MM.yyyy"
                isClearable={!locked}
                disabled={locked}
                placeholderText="zz.ll.aaaa"
                className="form-control form-control-sm"
                wrapperClassName="dp-w120"
              />
            </InputGroup>
          </Form.Group>
        </Col>

        <Col md="auto">
          <Form.Group controlId="bxinput_date">
            <Form.Label>Data intrare in contab</Form.Label>
            <InputGroup size="sm" className="w-auto">
              <DatePicker
                selected={fromISOToDate(value.bxinput_date)}
                onChange={setBxinputDate}
                dateFormat="dd.MM.yyyy"
                isClearable={!locked}
                disabled={locked}
                placeholderText="zz.ll.aaaa"
                className="form-control form-control-sm"
                wrapperClassName="dp-w120"
              />
            </InputGroup>
          </Form.Group>
        </Col>
        {/* <Button variant="danger" size="sm" onClick={testSetTipFactura}>
          TEST
        </Button> */}
        <Col md="auto">
          <Form.Group controlId="bxdatascadenta">
            <Form.Label>Scadenta</Form.Label>
            <InputGroup size="sm" className="w-auto">
              <DatePicker
                selected={fromISOToDate(value.bxdatascadenta)}
                onChange={setBxdatascadenta}
                dateFormat="dd.MM.yyyy"
                isClearable={!locked}
                disabled={locked}
                placeholderText="zz.ll.aaaa"
                className="form-control form-control-sm"
                wrapperClassName="dp-w120"
              />
            </InputGroup>
          </Form.Group>
        </Col>

        {/* ==== Cautare contact (async paginate) ==== */}
        <Col md={4}>
          <Form.Group controlId="contact_id">
            <Form.Label>Furnizor</Form.Label>

            <div className="d-flex gap-2 align-items-start ">
              <div
                role="button"
                onClick={() => !locked && setClientPicker(true)}
                className={`header-clickable w-100 ${locked ? "disabled" : ""}`}
                title={locked ? "" : "Click pentru a alege contactul"}
              >
                <Form.Control
                  name={`contact_${uniq}`}
                  readOnly
                  autoComplete="off"
                  onFocus={(e) => {
                    e.target.readOnly = false;
                  }}
                  disabled={locked}
                  value={value.contact_label || ""}
                  placeholder="Click pentru a alege contactul..."
                />
              </div>

              {/* <Button
                variant="secondary"
                className="ms-2"
                onClick={() =>
                  window.open(`/iesire/${value.id}/print`, "_blank")
                }
              >
                Print
              </Button> */}
            </div>

            <ClientPickerModal
              show={clientPicker}
              onHide={() => setClientPicker(false)}
              minChars={0}
              onPick={(opt) => {
                console.log("PICK client:", opt);
                onPickContact(opt);
              }}
            />
          </Form.Group>
        </Col>

        {/* <Col md={2}>
          <Form.Group controlId="bxcont_id">
            <Form.Label>bxcont_id No</Form.Label>
            <Form.Control value={value.bxcont_id || ""} readOnly />
          </Form.Group>
        </Col> */}
        {/* <Col md={2}>
          <Form.Group controlId="bxcont_id">
            <Form.Label>Cont furnizor</Form.Label>
            <Form.Control
              readOnly
              value={
                supplierAcc
                  ? `${supplierAcc.code}${supplierAcc.denumire ? " — " + supplierAcc.denumire : ""}`
                  : ""
              }
              placeholder="(nesetat)"
            />
          </Form.Group>
        </Col> */}

        {(!value.tip_document || value.tip_document === "Factura" || value.tip_document === "Bon fiscal") && (
          <Col md={4}>
          <Form.Group controlId="tip_factura_intrare_id">
            <Form.Label>Clasificare fiscală</Form.Label>

            <div className="d-flex gap-2 align-items-start">
              <div
                role="button"
                onClick={() => !locked && openTipFacturaPicker()}
                className={`header-clickable w-100 ${locked ? "disabled" : ""}`}
                title={locked ? "" : "Click pentru a alege clasificarea fiscală"}
              >
                {/* <Form.Control
                  readOnly
                  disabled={locked}
                  value={intrareClassificationLabel(value.tip_factura, value.tip_factura_label)}
                  placeholder="Click pentru a alege clasificarea fiscală..."
                /> */}
                <Form.Control
                  readOnly
                  disabled={locked}
                  value={intrareClassificationLabel(value.tip_factura, value.tip_factura_label)}
                  placeholder="Click pentru a alege clasificarea fiscală..."
                  onClick={() => !locked && setTipFacturaPicker(true)}
                  style={{ cursor: locked ? "default" : "pointer" }}
                />
              </div>

              {/* <Button
                        variant="outline-primary"
                        disabled={locked}
                        onClick={() => setTipFacturaPicker(true)}
                      >
                        Alege
                      </Button>
        
                      {doc.tip_factura_intrare_id && (
                        <Button
                          variant="outline-secondary"
                          disabled={locked}
                          onClick={() => {
                            setField("tip_factura_intrare_id", null);
                            setField("tip_factura_intrare_id", "");
                          }}
                        >
                          Sterge
                        </Button>
                      )} */}
            </div>
          </Form.Group>
        </Col>
          )}

        {isForeignCurrency ? (
          <>
            <Col md={2}>
              <Form.Group controlId="bxvaluta_curs">
                <Form.Label>Curs BNR</Form.Label>
                <Form.Control
                  type="number"
                  step="0.0001"
                  disabled={locked}
                  value={value.bxvaluta_curs || ""}
                  onChange={(e) => setField("bxvaluta_curs", e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group controlId="bxcurs_invoice">
                <Form.Label>Curs Factura</Form.Label>
                <Form.Control
                  type="number"
                  step="0.0001"
                  disabled={locked}
                  value={value.bxcurs_invoice || ""}
                  onChange={(e) => setField("bxcurs_invoice", e.target.value)}
                />
              </Form.Group>
            </Col>
          </>
        ) : (
          !firmaTvaIncasare && (
            <Col md="auto" className="d-flex align-items-end">
              <Form.Group controlId="e_tva_inc" className="mb-2">
                <Form.Check
                  type="checkbox"
                  id="e_tva_inc"
                  label="TVA la incasare"
                  disabled={locked}
                  checked={!!value.e_tva_inc}
                  onChange={(e) =>
                    setField("e_tva_inc", e.target.checked ? 1 : 0)
                  }
                  className="fw-semibold text-secondary"
                />
              </Form.Group>
            </Col>
          )
        )}
      </Row>
      <hr className="my-4" />
      {(value.linii || []).some(ln => ln.source_aviz_line_id) && (
        <Alert variant="info">
          Factură din aviz: poți reduce cantitatea pentru facturare parțială.
          Prețul este cel din aviz; TVA-ul facturii se selectează explicit.
          Recepția rămâne pe aviz, fără un NIR nou pe factură.
          {value.id && <div>Legături aviz: {(value.linii || []).filter(ln => ln.source_aviz_line_id).map(ln => `linia #${ln.source_aviz_line_id}`).join(", ")}</div>}
        </Alert>
      )}
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h5 className="mb-0">Linii</h5>
        <div className="d-flex gap-2">
          <Button
            type="button"
            variant="outline-primary"
            onClick={() => {
              if (!value.contact_id) {
                toast.warning(
                  "Te rugam sa selectezi mai intai un furnizor/client.",
                );
                return;
              }
              setShowAvizPicker(true);
            }}
            disabled={locked}
          >
            Facturare aviz
          </Button>
          <Button
            type="button"
            variant="outline-warning"
            onClick={() => {
              if (!value.contact_id) {
                toast.warning("Te rugam sa selectezi mai intai un furnizor.");
                return;
              }
              setShowStornoPicker(true);
            }}
            disabled={locked}
          >
            Storno
          </Button>
          <Button type="button" onClick={addLine} disabled={locked}>
            + Linie
          </Button>
        </div>
      </div>
      <Table striped bordered hover size="sm" responsive>
        <thead>
          <tr>
            <th>Part ID</th>
            <th>Observatii</th>
            <th>UM</th>
            <th>Cant.</th>
            <th>Pret</th>
            <th>Valoare</th>
            {isPlatitorTva && <th>Cota TVA</th>}
            {isPlatitorTva && <th>TVA</th>}
            <th>Total</th>
            <th>Cont</th>
            <th>Expira la</th>

            <th></th>
            {debugging && <th style={{ width: 260 }}>Debug</th>}
          </tr>
        </thead>
        <tbody>
          {value.linii.map((ln, idx) => {
            const is6xx = String(ln.bxcont_code || "").startsWith("6");

            const sumAlloc = (ln.cost_alloc || []).reduce(
              (s, a) => s + (Number(a.amount) || 0),
              0,
            );

            const diff = (Number(ln.bxvamount) || 0) - sumAlloc;
            const hasAlloc = (ln.cost_alloc || []).length > 0;
            const ok = Math.abs(diff) <= 0.01;

            return (
              <tr key={ln.row_uid}>
                <td style={{ minWidth: 280 }}>
                  <div
                    role="button"
                    onClick={() => !locked && openPartForLine(ln.row_uid)}
                    className={`header-clickable w-100 ${locked ? "disabled" : ""}`}
                    title={locked ? "" : "Click pentru a alege produs"}
                  >
                    <Form.Control
                      name={`bxpart_label_${uniq}_${ln.row_uid}`}
                      readOnly
                      autoComplete="off"
                      onFocus={(e) => {
                        e.target.readOnly = false;
                      }}
                      disabled={locked}
                      value={
                        ln.bxpart_label ||
                        (ln.bxpart
                          ? `${ln.bxpart.cod || ""} ${ln.bxpart.denumire || ""}`.trim()
                          : ln.bxpart_id
                            ? `Part #${ln.bxpart_id}`
                            : "")
                      }
                      placeholder="Click pentru a alege produs..."
                      style={{ cursor: locked ? "default" : "pointer" }}
                    />
                  </div>
                </td>
                <td style={{ width: 260 }}>
                  <Form.Control
                    name={`bxdescr_${uniq}_${ln.row_uid}`}
                    size="sm"
                    autoComplete="off"
                    value={ln.bxdescr || ""}
                    disabled={locked}
                    onChange={(e) =>
                      updateLine(ln.row_uid, { bxdescr: e.target.value })
                    }
                    placeholder="Observatii linie..."
                  />
                </td>
                <td style={{ width: 90 }}>
                  <Form.Control
                    name={`um_${uniq}_${ln.row_uid}`}
                    size="sm"
                    autoComplete="off"
                    value={umById[ln.bxum_id] || ""}
                    disabled
                    className="text-center"
                    title={`UM id=${ln.bxum_id ?? ""}`}
                  />
                </td>
                <td style={{ width: 120 }}>
                  <Form.Control
                    type="text"
                    inputMode="decimal"
                    disabled={locked}
                    value={ln.bxcantitate ?? ""}
                    onChange={(e) =>
                      updateLine(ln.row_uid, { bxcantitate: e.target.value })
                    }
                  />
                </td>
                <td style={{ width: 120 }}>
                  <Form.Control
                    type="text"
                    inputMode="decimal"
                    disabled={locked || !!ln.source_aviz_line_id}
                    value={ln.bxvprice ?? ""}
                    onChange={(e) =>
                      updateLine(ln.row_uid, { bxvprice: e.target.value })
                    }
                  />
                </td>
                <td style={{ width: 110 }}>{ln.bxvamount}</td>
                {isPlatitorTva && (
                  <td
                    role={locked ? undefined : "button"}
                    onClick={() => !locked && openVatPicker(ln.row_uid)}
                    className={`text-end small ${!locked ? "td-clickable td-picker" : "text-muted"}`}
                    title={locked ? "" : "Click pentru a alege TVA"}
                    style={{
                      width: 90,
                      cursor: locked ? "default" : "pointer",
                      verticalAlign: "middle",
                    }}
                  >
                    {ln.vat_code || ln.vat_label || (ln.vat_rate !== undefined && ln.vat_rate !== null
                      ? `${ln.vat_rate}%`
                      : "19%")}
                  </td>
                )}
                {isPlatitorTva && (
                  <td style={{ width: 110 }}>{ln.bxvatv_amount}</td>
                )}
                <td style={{ width: 110 }}>{ln.bxtotalv_amount}</td>

                <td style={{ minWidth: 80 }}>
                  <div className="d-flex gap-2 align-items-center">
                    <Form.Control
                      name={`account_${uniq}_${ln.row_uid}`}
                      size="sm"
                      readOnly
                      autoComplete="off"
                      onFocus={(e) => {
                        if (!locked) e.target.readOnly = false;
                      }}
                      disabled={locked}
                      style={{
                        cursor: locked ? "default" : "pointer",
                        background: locked ? "#e9ecef" : "white",
                      }}
                      onClick={() => !locked && openAccountForLine(ln.row_uid)}
                      value={
                        ln?.bxcont_code
                          ? `${ln.bxcont_code}${
                              ln.bxcont_name ? " – " + ln.bxcont_name : ""
                            }`
                          : ln?.bxcont_id
                            ? `#${ln.bxcont_id}`
                            : ""
                      }
                      placeholder="Alege cont…"
                    />
                  </div>
                </td>

                <td style={{ width: 110 }}>
                  <DatePicker
                    selected={fromISOToDate(ln.data_expirare)}
                    onChange={(d) =>
                      updateLine(idx, {
                        data_expirare: ymdToISODateTime(toYMD(d), "00", "00"),
                      })
                    }
                    dateFormat="dd.MM.yyyy"
                    isClearable={!locked}
                    disabled={locked}
                    placeholderText="zz.ll.aaaa"
                    className="form-control form-control-sm"
                    wrapperClassName="w-auto"
                  />
                </td>

                <td style={{ minWidth: 90 }}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Button
                      size="sm"
                      variant="outline-danger"
                      onClick={() => removeLine(ln.row_uid)}
                      disabled={locked}
                      style={{ marginLeft: "auto" }}
                    >
                      ✕
                    </Button>
                  </div>
                </td>
                {debugging && (
                  <td
                    style={{
                      fontFamily: "monospace",
                      fontSize: 12,
                      whiteSpace: "nowrap",
                    }}
                  >
                    <div>id: {ln.id ?? "-"}</div>

                    <div>uid: {ln.row_uid ?? "-"}</div>
                    <div>cont: {ln.bxcont_code ?? ln.bxcont_id ?? "-"}</div>
                    <div>
                      cc:{" "}
                      {(ln.cost_alloc?.length ?? 0) === 0
                        ? "-"
                        : ln.cost_alloc
                            .map((a) => `${a.cost_center_id}:${a.amount}`)
                            .join(" | ")}
                    </div>
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
      </Table>
      <InputTotals lines={value.linii} currency={Number(value.bxvaluta_id || 1) === 2 ? "EUR" : Number(value.bxvaluta_id || 1) === 3 ? "USD" : "RON"} />
      <InputCostAllocation ref={allocationRef} doc={value} disabled={locked || submitting}
        onChange={cost_allocation => onChange({ ...value, cost_allocation })} />
      <PartPickerModal
        show={showPartModal}
        onHide={() => setShowPartModal(false)}
        onPick={handlePickPart}
        filter={{ tip_grupa_in: "1,2" }}
      />

      <AccountPickerModal
        show={showAccPicker}
        onHide={closeAccountPicker}
        onSelect={onPickAccount}
        onPick={onPickAccount}
      />

      <TipFacturaIntrarePickerModal
        excludeDocumentKinds
        show={tipFacturaPicker}
        onHide={() => setTipFacturaPicker(false)}
        minChars={0}
        onPick={(opt) => {
          // opt: { id, label }
          onChange?.((prev) => ({
            ...prev,
            tip_factura: opt.id,
            tip_factura_label: intrareClassificationLabel(opt.id, opt.label),
          }));
          setTipFacturaPicker(false);
        }}
      />
      <AvizePickerModal
        show={showAvizPicker}
        onHide={() => setShowAvizPicker(false)}
        contactId={value.contact_id}
        onPick={handlePickAviz}
      />
      <StornoPickerModal
        show={showStornoPicker}
        onHide={() => setShowStornoPicker(false)}
        contactId={value.contact_id}
        onPick={handlePickStorno}
      />

      <VatPickerModal
        show={vatPicker.show}
        onHide={() => setVatPicker({ show: false, row: null })}
        onPick={(opt) => {
          const rowUid = vatPicker.row;
          if (rowUid == null) return;
          updateLine(rowUid, {
            bxvat_id: opt.id,
            vat_rate: opt.procent,
            vat_label: opt.label,
            vat_code: opt.label,
          });
        }}
      />
      <div className="d-flex justify-content-between align-items-center border-top pt-3">
        <div className="text-muted">
          Total document: <strong>{value.bxgvalue}</strong>
        </div>
        <div>
          {!locked && (
            <Button type="submit" variant="dark" disabled={submitting}>
              {submitting ? "Se salveaza…" : "Salveaza"}
            </Button>
          )}
        </div>
      </div>
    </Form>
  );
}

export function CostCenterSplitModal({
  show,
  onHide,
  centers,
  initialSplit,
  total = 0,
  onSave,
  title = "Impartire pe centre de cost",
}) {
  const [rows, setRows] = useState([]);
  const [err, setErr] = useState("");

  // normalize centers -> array
  const centersArr = useMemo(() => {
    if (Array.isArray(centers)) return centers;
    if (Array.isArray(centers?.items)) return centers.items;
    return [];
  }, [centers]);

  const totalNum = Number(total || 0);

  useEffect(() => {
    if (!show) return;

    setErr("");

    const safeInitial = Array.isArray(initialSplit) ? initialSplit : [];

    // daca avem split salvat, il afisam; altfel, initializam pe centre
    setRows(
      safeInitial.length
        ? safeInitial.map((r) => ({
            cost_center_id: Number(r.cost_center_id),
            amount: r.amount ?? "",
          }))
        : centersArr.map((c) => ({
            cost_center_id: Number(c.cost_center_id), // ✅ AICI
            amount: "",
          })),
    );
  }, [show, initialSplit, centersArr]);

  const sumRows = useMemo(() => {
    return (rows || []).reduce((s, r) => s + (Number(r.amount) || 0), 0);
  }, [rows]);

  const canSave = useMemo(() => {
    if (!Array.isArray(rows) || rows.length === 0) return false;
    if (rows.some((r) => !r.cost_center_id)) return false;

    // daca ai total > 0, cere sa se potriveasca
    if (totalNum > 0) {
      const diff = Math.abs(sumRows - totalNum);
      return diff < 0.0001;
    }
    return true;
  }, [rows, totalNum, sumRows]);

  // const payload = {
  //   ...value,
  //   linii: (value.linii || []).map((ln) => ({
  //     ...ln,
  //     cost_alloc: Array.isArray(ln.cost_alloc) ? ln.cost_alloc : [],
  //   })),
  // };

  const handleSave = () => {
    setErr("");

    const cleaned = (rows || [])
      .map((r) => ({
        cost_center_id: Number(r.cost_center_id),
        amount: Number(r.amount) || 0,
      }))
      .filter((r) => r.cost_center_id && r.amount !== 0);

    if (totalNum > 0) {
      const diff = Math.abs(
        cleaned.reduce((s, r) => s + (Number(r.amount) || 0), 0) - totalNum,
      );
      if (diff >= 0.0001) {
        setErr(
          `Suma pe centre (${sumRows}) trebuie sa fie egala cu totalul (${totalNum}).`,
        );
        return;
      }
    }

    onSave?.(cleaned);
    onHide?.();
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {err ? <Alert variant="danger">{err}</Alert> : null}

        <Row className="mb-2">
          <Col>
            <div className="text-muted" style={{ fontSize: 13 }}>
              Total linie: <b>{totalNum}</b> &nbsp;|&nbsp; Suma alocata:{" "}
              <b>{sumRows}</b>
            </div>
          </Col>
        </Row>

        <Table size="sm" bordered hover responsive className="mb-0">
          <thead>
            <tr>
              <th style={{ width: "65%" }}>Centru de cost</th>
              <th className="text-end" style={{ width: "35%" }}>
                Suma---
              </th>
            </tr>
          </thead>
          <tbody>
            {(rows || []).map((r, idx) => {
              const name =
                centersArr.find(
                  (c) => Number(c.cost_center_id) === Number(r.cost_center_id),
                )?.cc_label || `CC#${r.cost_center_id}`;

              return (
                <tr key={idx}>
                  <td>{name}</td>
                  <td className="text-end">
                    <Form.Control
                      size="sm"
                      className="text-end"
                      type="number"
                      step="0.01"
                      value={r.amount ?? ""}
                      onChange={(e) => {
                        const v = e.target.value;
                        setRows((prev) =>
                          prev.map((x, i) =>
                            i === idx ? { ...x, amount: v } : x,
                          ),
                        );
                      }}
                    />
                  </td>
                </tr>
              );
            })}

            {rows?.length === 0 ? (
              <tr>
                <td colSpan={2} className="text-muted">
                  Nu exista centre de cost pentru acest cont..
                </td>
              </tr>
            ) : null}
          </tbody>
        </Table>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Renunta
        </Button>
        <Button variant="primary" onClick={handleSave} disabled={!canSave}>
          Salveaza
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
